import { Modal, Input, Select, message } from 'antd'
import React, { useCallback, useContext, useState } from 'react'
import { ErrorContext } from '../../../context'
import R from 'ramda'
import { saveAPSAdMappingUpdate } from 'api/pgads'

const TYPE = ['ROLE', 'COMPANY', 'STATION']
const { Option } = Select

const ApsAdModal = ({
  apiTargetInfo,
  hide,
  data = {},
  allData = [],
  companyNameMap = {},
  stationNameMap = {},
  roleMap = {},
}) => {
  const { onError } = useContext(ErrorContext)
  // const { setSpinning, spinning } = useContext(SpinContext)
  const { isNew } = data
  const [baseData, setBaseData] = useState(data)
  const updateData = (property, value) => {
    setBaseData(d => {
      return { ...d, [property]: value }
    })
  }

  const onOk = () => {
    const data = allData.map(
      d =>
        d.type.toLowerCase() +
        '-' +
        d.adName.toLowerCase() +
        '-' +
        d.gadsName.toLowerCase()
    )
    let validation = ''
    if (baseData.type === undefined || baseData.type === '') {
      validation = 'Type Cannot be empty'
      message.error(validation)
    } else if (baseData.adName === undefined || baseData.adName === '') {
      validation = 'AD Name Cannot be empty'
      message.error(validation)
    } else if (baseData.gadsName === undefined || baseData.gadsName === '') {
      validation = 'GADS Name Cannot be empty'
      message.error(validation)
    } else if (
      data.includes(
        baseData.type.toLowerCase() +
          '-' +
          baseData.adName.toLowerCase() +
          '-' +
          baseData.gadsName.toLowerCase()
      )
    ) {
      message.error('Data is repeated!')
    } else {
      saveAPSAdMappingUpdate(apiTargetInfo)([baseData]).fork(onError, _ => {
        message.info('Data Saved.')
        hide(true)
      })
    }
  }

  const sortData = useCallback(objMap => {
    const final = R.compose(
      R.sortWith([R.ascend(R.prop('displayName'))]),
      R.map(k => ({ id: k, displayName: objMap[k] })),
      // R.filter(f =>
      //   typeShift === 'COMPANY'
      //     ? companyRoleIdList.includes(f)
      //     : stationRoleIdList.includes(f)
      // ),

      R.keys
    )(objMap)

    return final
  }, [])

  const sortRole = objMap =>
    R.compose(
      R.sortWith([R.ascend(R.prop('displayName'))]),
      R.map(k => ({ id: k, displayName: objMap[k][0].displayName })),
      R.keys
    )(objMap)

  return (
    <Modal
      title={
        isNew ? `Create AD Mapping` : `Update ( ${data.type} - ${data.adName} )`
      }
      width="60vw"
      visible
      onCancel={_ => hide()}
      centered
      bodyStyle={{ overflowY: 'auto' }}
      maskClosable={false}
      // okButtonProps={{ loading: spinning }}
      // cancelButtonProps={{ loading: spinning }}
      onOk={onOk}
      okText="Save"
    >
      <div>
        <div>
          <div>
            <label>Type</label>
          </div>
          <div>
            <Select
              name="type"
              value={baseData.type}
              onChange={val => {
                updateData('type', val)
                updateData('gadsName', undefined)
              }}
              style={{ marginBottom: '10px', display: 'block', width: 'auto' }}
              placeholder="Enter Type"
              disabled={!isNew}
            >
              {TYPE.map(status => (
                <Option key={status}>{status}</Option>
              ))}
            </Select>
          </div>
        </div>
        <label>AD Name</label>
        <Input
          placeholder="Enter AD Name"
          name="adName"
          onChange={e => updateData('adName', e.target.value)}
          value={baseData.adName}
          style={{ marginBottom: '10px' }}
          disabled={!isNew}
        />
        <div>{baseData.type && <label>GADS Name</label>}</div>
        {baseData.type === 'ROLE' && (
          <div>
            <Select
              name="gadsName"
              value={baseData.gadsName}
              onChange={val => updateData('gadsName', val)}
              style={{ marginBottom: '10px', display: 'block', width: 'auto' }}
              placeholder="Enter GADS Name"
            >
              {sortRole(roleMap).map(p => (
                <Option key={p.id}>{p.displayName}</Option>
              ))}
            </Select>
          </div>
        )}
        {baseData.type === 'COMPANY' && (
          <div>
            <Select
              name="gadsName"
              value={baseData.gadsName}
              onChange={val => updateData('gadsName', val)}
              style={{ marginBottom: '10px', display: 'block', width: 'auto' }}
              placeholder="Enter GADS Name"
            >
              {sortData(companyNameMap, 'COMPANY').map(p => (
                <Option key={p.id}>{p.displayName}</Option>
              ))}
            </Select>
          </div>
        )}
        {baseData.type === 'STATION' && (
          <div>
            <Select
              name="gadsName"
              value={baseData.gadsName}
              onChange={val => updateData('gadsName', val)}
              style={{ marginBottom: '10px', display: 'block', width: 'auto' }}
              placeholder="Enter GADS Name"
            >
              {sortData(stationNameMap, 'STATION').map(p => (
                <Option key={p.id}>{p.displayName}</Option>
              ))}
            </Select>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ApsAdModal

// release test
